<igx-grid #grid [data]="accounts" [allowFiltering]="true">
    <igx-paginator />
    <igx-column field="skontroNr" [sortable]="true" header="{{ 'ShareholderAccount.Skontro' | translate }}" [resizable]="true" />
    <igx-column
        field="accountTypeDescription"
        [sortable]="true"
        header="{{ 'ShareholderAccount.AccountTypeDescription' | translate }}"
        [resizable]="true" />
    <igx-column
        field="numberOfShares"
        [sortable]="true"
        header="{{ 'Shareholders.NumberOfShares' | translate }}"
        [resizable]="true"
        dataType="number">
        <ng-template igxCell let-cell="cell">
            {{ cell.value | slNumber }}
        </ng-template>
    </igx-column>
    @if (isFromTraders) {
        <igx-column
            field="shareholderId"
            [sortable]="true"
            header="{{ 'Shareholders.Id' | translate }}"
            [resizable]="true"
            dataType="number">
            <ng-template igxCell let-cell="cell">
                {{ cell.value | slNumber }}
            </ng-template>
        </igx-column>
    }
    @if (isFromTraders) {
        <igx-column field="shareholderDisplayName" [sortable]="true" header="{{ 'Shareholders.Name' | translate }}" [resizable]="true" />
    }
    <igx-column
        field="traderDisplayName"
        [sortable]="true"
        header="{{ 'ShareholderAccount.TraderDisplayName' | translate }}"
        [resizable]="true" />
    <igx-column
        field="bankAccountReference"
        [sortable]="true"
        header="{{ 'ShareholderAccount.BankAccountReference' | translate }}"
        [resizable]="true" />
    <igx-column
        field="paymentAccountIbanOrNumber"
        [sortable]="true"
        header="{{ 'PaymentAccount.IbanOrNumber' | translate }}"
        [resizable]="true" />
</igx-grid>
